module.exports = __webpack_public_path__ + "static/media/9mobile.29f2306e.svg";